/* ========================================================================
   Info Blocks Grid
 ========================================================================== */

app.infoBlocksGrid = (function () {
  'use strict';

  const KEY_ENTER = 'Enter';
  const KEY_SPACE = 'Space';
  const KEY_ESCAPE = 'Escape';

  function init() {
    const infoBlocks = document.querySelectorAll('[data-info-grid]');

    infoBlocks.forEach((block) => {
      const items = block.querySelectorAll('[data-info-grid-item]');

      items.forEach((item) => {
        const trigger = item.querySelector('[data-info-grid-trigger]');
        const closeButton = item.querySelector('[data-info-grid-close]');
        const popout = item.querySelector('[data-info-grid-popout]');

        if (!trigger || !closeButton || !popout) return;

        trigger.addEventListener('keydown', (event) => {
          switch (event.code) {
            case KEY_ENTER:
            case KEY_SPACE:
              event.preventDefault();
              openItem(item, trigger, popout, true);
          }
        });

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          closeAll(block);
          openItem(item, trigger, popout);
        });

        closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          closeItem(item, trigger, popout);
        });
      });
    });
  }

  function openItem(item, trigger, popout, setFocus) {
    setFocus = setFocus || false;

    item.classList.add('is-expanded');
    trigger.setAttribute('aria-expanded', true);
    popout.setAttribute('aria-hidden', false);

    // a11y: switch focus to first link
    const firstLink = popout.querySelector('a');
    if (setFocus && firstLink) firstLink.focus();

    const title = item.querySelector('[data-info-grid-item-title]');

    // DATALAYER
    app.dataLayer.pushEvent('infoBlockGridExpand', {
      pageUrl: window.location.pathname,
      title: title.textContent.replace('"', '').replace("'", ''),
    });
  }

  function closeItem(item, trigger, popout) {
    item.classList.remove('is-expanded');
    trigger.setAttribute('aria-expanded', false);
    popout.setAttribute('aria-hidden', true);
  }

  function closeAll(block) {
    const items = block.querySelectorAll('.is-expanded');
    const triggers = block.querySelectorAll('[aria-expanded="true"]');
    const popouts = block.querySelectorAll('[aria-hidden="false"]');

    items.forEach((item) => {
      item.classList.remove('is-expanded');
    });

    triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', false);
    });

    popouts.forEach((popout) => {
      popout.setAttribute('aria-hidden', true);
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
